import React, { useState } from 'react';
import { flowRight } from 'lodash/fp';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';

import Fields from 'ui/form/FieldsForm';
import Paragraph from 'ui/Paragraph';
import DateFormater from 'ui/formats/Date';
import { ConnectorStatusTable } from '../common/Status';

import { ActionTypes } from '../Consts';
import { withAppContext } from '../../../AppContext';

const styles = theme => ({
    root: {
        margin: `${theme.spacing(2)}px 0`,
    },
    copyWarn: {
        color: '#f00',
        fontWeight: 500,
    },
    label: {
        fontWeight: 500,
    },
    tokenInfo: {
        '& button': {
            marginLeft: 160,
        },
    },
    tokenInfoCreated: {
        marginRight: theme.spacing(),
    },
    downloadLink: {
        marginLeft: 6,
        color: theme.palette.text.blue,
        textDecoration: 'underline',
        fontWeight: 500,
    },
    instructions: {
        marginTop: theme.spacing(2),
        '& > label': {
            fontWeight: 500,
        },
        '& > ol': {
            padding: '0 0 0 14px',
            margin: `${theme.spacing()}px 0 ${theme.spacing(2)}px 0`,
        },
    },
    learnMore: {
        color: theme.palette.text.blue,
    },
    statusTable: {
        margin: `${theme.spacing(2)}px 0`,
    },
});

function GeneratTab({ classes, app, connector, mode, onAction }) {
    const { identifier } = connector;
    const [token] = useState(connector.api_key);
    const {
        settings: { brand },
    } = app;
    const onCreateNew = () => onAction(ActionTypes.CREATE_NEW, { identifier });
    return (
        <div className={classes.root}>
            {mode === 'view' && (
                <React.Fragment>
                    <Paragraph>
                        Copy the authentication token below and use it to finish
                        the AD Connector configuration on your domain controller
                        or server. You will also need to download the AD
                        Connector the link on the top of this page.
                    </Paragraph>
                    <Typography component="div">
                        <div className={classes.label}>
                            Authentication token
                        </div>
                        <Fields.CopyTextField
                            value={token}
                            onChange={() => {}}
                        />
                        <div className={classes.copyWarn}>
                            Copy the authentication token now, it will not be
                            shown again
                        </div>
                    </Typography>
                </React.Fragment>
            )}
            {(mode === 'edit' || mode === 'details') && (
                <Typography component="div" className={classes.tokenInfo}>
                    <div className={classes.label}>Authentication token</div>
                    <span className={classes.tokenInfoCreated}>Created:</span>
                    <DateFormater value={connector.api_key_generation_date} />
                    {mode === 'edit' && (
                        <Button color="secondary" onClick={onCreateNew}>
                            Create new
                        </Button>
                    )}
                </Typography>
            )}
            <ConnectorStatusTable connector={connector} />
            <Typography component="div" className={classes.instructions}>
                <div className={classes.label}>Instructions</div>
                <ol>
                    <li>
                        Download the
                        <Link
                            className={classes.downloadLink}
                            href={brand.active_directory_download_app_url}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            AD Connector
                        </Link>
                    </li>
                    <li>
                        Login as an administrator on the domain controller or
                        server where you will run the AD Connector.
                    </li>
                    <li>Install and configure the AD Connector.</li>
                </ol>
            </Typography>
        </div>
    );
}

export default flowRight(withStyles(styles), withAppContext)(GeneratTab);
